import React from "react";

// Styles
import "./ColorSection.scss";

// Types
import { ChangeEvent } from "react";

// Hooks
import { useReducer } from "react";

// Components
import { IonLabel } from "@ionic/react";
import InputFactory from "../../../components/Factories/Input/InputFactory";

type ColorSectionProps = {
  elementColors: ColorObject[];
  textColors: ColorObject[];
  gradientPreview?: boolean;
  noBorder?: boolean;
  changeHandler: (event: ChangeEvent<HTMLInputElement>) => void;
};

type ColorObject = {
  label: string;
  value: string;
  name: string;
};

type ColorsArrayToUpdate = "elementColors" | "textColors";

export default function ColorSection({ elementColors, textColors, gradientPreview = false, noBorder = false, changeHandler }: ColorSectionProps) {
  const [colors, dispatch] = useReducer(coloursReducer, { elementColors, textColors });

  return (
    <section className={`settings-color-section ${noBorder ? "settings-color-section--no-border" : ""}`}>
      <div className="settings-color-section__input">
        {elementColors.map((elementColor: ColorObject, index: number) => {
          return renderColorRow(elementColor, "elementColors", index);
        })}

        {renderColorRow(textColors[0], "textColors")}
      </div>

      <div className={`settings-color-section__preview ${gradientPreview && "settings-color-section__preview--gradient"}`}>
        <span>Preview</span>
        {gradientPreview ? (
          <div style={{ color: colors.textColors[0].value, background: `linear-gradient(121deg, ${colors.elementColors[0].value}, ${colors.elementColors[1].value})` }}>Test</div>
        ) : (
          elementColors.map((elementColor: ColorObject, index: number) => {
            const backgroundColor = colors.elementColors[index].value;
            const border = backgroundColor?.toLowerCase() === "#ffffff" ? "1px solid #707070" : "none";
            const color = colors.textColors[0].value;

            return (
              <div key={index} style={{ backgroundColor, color, border }}>
                test
              </div>
            );
          })
        )}
      </div>
    </section>
  );

  function renderColorRow(color: ColorObject, colorsArrayToUpdate: ColorsArrayToUpdate, key?: number) {
    return (
      <div className="settings-color-section__row" key={key}>
        <InputFactory type="color" value={color.value} name={color.name} onIonChange={(props: any) => handleChange(props, colorsArrayToUpdate)} />
        <IonLabel>{color.label}</IonLabel>
      </div>
    );
  }

  function handleChange(props: any, colorsArrayToUpdate: ColorsArrayToUpdate) {
    const originalColor = colors[colorsArrayToUpdate].find((color: ColorObject) => color.name === props.detail.name);
    const originalColorIndex = colors[colorsArrayToUpdate].findIndex((color: ColorObject) => color.name === props.detail.name);
    const updatedColor = { ...originalColor, value: props.detail.value };

    let payload = [...colors[colorsArrayToUpdate]];
    payload[originalColorIndex] = updatedColor;

    dispatch({ type: colorsArrayToUpdate, payload: payload });
    changeHandler(props);
  }

  function coloursReducer(state: any, action: any) {
    switch (action.type) {
      case "elementColors":
        return { ...state, elementColors: action.payload };
      case "textColors":
        return { ...state, textColors: action.payload };
      default:
        return state;
    }
  }
}
